module.exports = __webpack_public_path__ + "static/img/11.b8bca4a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/sp/11.png
// module id = FD3J
// module chunks = 0